export const actions = {
  async nuxtServerInit({ commit }, { isDev, req, query }) {
    commit('cart/SET_TOTALS', req.cart.totalSummary)

    if (!req.cart.isSubscriber) {
      commit('cart/SET_ITEMS', req.cart.cartItems)
    } else {
      const cartItems = await req.cart.getCartItems()
      commit('cart/SET_ITEMS', cartItems)
    }

    if (req.cart.leadEmail) {
      commit('quiz/SET_EMAIL', req.cart.leadEmail)
    }

    if (req.cart.isUser) {
      commit('user/SET_USER', req.user)
      commit('user/SET_PRODUCT_ORDER', req.cart.productOrder)
      commit('user/SET_REPORT', {
        ...req.cart.customerReport,
        recommendedItems: req.cart.recommendedItems
      })
    }

    if (req.cart.isUser && !req.cart.isSubscriber) {
      commit('checkout/SET_REFERRAL', req.cart.referralCode)
      commit('checkout/SET_COUPON_CODE', req.cart.couponCode)
      commit('checkout/SET_COUPON', req.cart.coupon)
      commit('checkout/SET_PLAN', req.cart.plan)
      commit('checkout/SET_FREE_TRIAL', req.cart.didFreeTrial)
      commit(
        'checkout/SET_USE_STORED_CARD',
        Boolean(req.user?.details?.creditCardLast4)
      )

      if (req.session.initialBagCount) {
        commit('checkout/SET_INITIAL_BAG_COUNT', req.session.initialBagCount)
      }

      if (Object.keys(req.cart.shipping)[0]) {
        commit('checkout/SET_SHIPPING', req.cart.shipping)
      }

      if (req.cart.sampleItems.length) {
        commit('cart/SET_SAMPLE_ITEMS', req.cart.sampleItems)
      }
    }

    if (req.cart.isSubscriber) {
      const orderCount = await req.cart.getOrderCount()

      commit('user/SET_ORDERS', orderCount)
    }

    if (req.cookies.features) {
      commit('ui/setFeatures', req.cookies.features)
    }

    commit('ui/setHostname', req.hostname)
  }
}

/**
 * Subscribe to bag mutations to emit Listrak events on client
 */
const subscribeToListrak = store => {
  store.subscribe(mutation => {
    if (process.client && mutation.type === 'cart/SET_BAG') {
      store.dispatch('cart/listrakEvent')
    }
  })
}

export const plugins = [subscribeToListrak]
